import axios from 'axios';
import qs from 'qs';
import { debounce } from 'lodash';
import { isEmpty } from 'ramda';

import { camelize, decamelize } from './keysConverter';
import { auth } from './authService';

const { CancelToken } = axios;

const csrfTokenInput = document.getElementsByName('csrf-token')[0];

axios.defaults.headers.delete['Content-Type'] = 'application/json';
axios.defaults.headers.delete['X-CSRF-Token'] = csrfTokenInput
  ? csrfTokenInput.content
  : null;

axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.post['X-CSRF-Token'] = csrfTokenInput
  ? csrfTokenInput.content
  : null;

axios.defaults.headers.put['Content-Type'] = 'application/json';
axios.defaults.headers.put['X-CSRF-Token'] = csrfTokenInput
  ? csrfTokenInput.content
  : null;

axios.defaults.headers.get['X-CSRF-Token'] = csrfTokenInput
  ? csrfTokenInput.content
  : null;
axios.defaults.headers.get['X-Requested-With'] = 'XMLHttpRequest';

export const createRequestToken = () => CancelToken.source();

export const updateTokens = (prevTokens, setRequestTokens) => {
  const requestToken = createRequestToken();
  setRequestTokens([...prevTokens, requestToken]);
  return requestToken;
};

export const cancelRequest = (requestTokens) => {
  if (!isEmpty(requestTokens)) {
    const requestToken = requestTokens.shift();
    requestToken.cancel('Cancel previous request for pet profiles');
  }
};

export const handleRequestCancel = (error, tokens, token, setTokensFunc) => {
  if (axios.isCancel(error)) {
    const index = tokens.findIndex((item) => item === token);
    const newRequestTokens = tokens.splice(index);
    setTokensFunc(newRequestTokens);
  }
};

export const loadWithDebounce = (func) => debounce(func, 300);

export default {
  get(url, params = {}, requestManager = {}) {
    return axios
      .get(url, {
        cancelToken: requestManager.token,
        params,
        headers: auth.getHeaders(),
        paramsSerializer: (parameters) =>
          qs.stringify(parameters, { arrayFormat: 'brackets' }),
      })
      .then(camelize);
  },

  post(url, json) {
    const body = decamelize(json);
    const headers = auth.getHeaders();
    return axios.post(url, body, { headers }).then(camelize);
  },

  put(url, json) {
    const body = decamelize(json);
    const headers = auth.getHeaders();
    return axios.put(url, body, { headers: headers }).then(camelize);
  },

  putMultipartFormData(url, formData) {
    return axios
      .put(url, formData, {
        headers: auth.headersMultipartFormData(),
        credentials: 'same-origin',
      })
      .then((response) => camelize(response.data));
  },

  delete(url, json) {
    const body = decamelize(json);
    const headers = auth.getHeaders();
    return axios.delete(url, { headers: headers }).then(camelize);
  },
};
